
import React from 'react'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Grid,
  Divider,
  makeStyles,
} from '@material-ui/core'
import PropTypes from 'prop-types'

/**
 *  a dialog for confirming unlocking of a user
 */

const UnlockCustomerAccountDialog = ({
  onClose,
  onConfirm,
  open,
}) => {
  const classes = useStyles()

  return (
    <Dialog
      open={open}
      aria-labelledby='title'
      maxWidth='sm'
      fullWidth
    >
      <Grid className={classes.m2}>
        <DialogTitle id='title'>
          <Typography component='div' variant='h4'>Nutzer wirklich entsperren?</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant='subtitle2' color='textSecondary'>Der Vorgang kann die Zahlungsabwicklung mit Swipe2Go verhindern oder zu anderen Komplikationen führen.</Typography>
        </DialogContent>
        <Divider variant='middle' className={classes.mb1} />
        <DialogActions>
          <Button autoFocus onClick={onClose} variant='outlined' color='primary'>
            <Typography variant='button' className={classes.button}>Schließen</Typography>
          </Button>
          <Button autoFocus onClick={onConfirm} variant='contained' color='primary'>
            <Typography variant='button' className={classes.button}>Entsperren</Typography>
          </Button>
        </DialogActions>
      </Grid>
    </Dialog>
  )
}

const useStyles = makeStyles(theme => ({
  centerSpinner: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(2),
  },
  mb1: {
    marginBottom: theme.spacing(1),
  },
  button: {
    paddingLeft: theme.spacing(6),
    paddingRight: theme.spacing(6),
  },
  error: {
    color: 'rgba(244, 67, 54)',
    marginBottom: theme.spacing(2),
  },
}))

UnlockCustomerAccountDialog.propTypes = {
  /** callback when dialog is cancelled */
  onClose: PropTypes.func.isRequired,
  /** callback when unlock is confirmed */
  onConfirm: PropTypes.func.isRequired,
  /** callback when email is sent, the dialog is opened */
  open: PropTypes.bool,
}
export default UnlockCustomerAccountDialog
